module.exports = __webpack_public_path__ + "img/sqrt-not.25b0c338.svg";